<template>
  <div>
    <div v-if="loading" class="loading-bar">
      <atom-spinner
        :animation-duration="1000"
        :size="60"
        color="#ff1d5e"
        class="mx-auto"
      />
    </div>
    <validation-popup
      :errorMessage="errorMessage"
      :warningPopup="warningPopup"
      :warningText="warningText"
      @closeWarning="warningPopup = false"
    ></validation-popup>
    <delete-popup
      :deletePopup="deleteTriggerPopup"
      title="Trigger"
      @deletePressed="deleteTrigger(delId)"
      @cancelPressed="deleteTriggerPopup = false"
    >
    </delete-popup>
    <delete-popup
      :deletePopup="deleteScenarioPopup"
      title="Scenario"
      @deletePressed="deleteScenario(delId)"
      @cancelPressed="deleteScenarioPopup = false"
    >
    </delete-popup>
    <div class="w-full">
      <div
        slot="no-body"
        class="tabs-container inventory_tabSec"
        id="view-customer-tab"
      >
        <ul class="heading-ul mb-3">
          <li>
            <router-link :to="{ path: '/setup/collection-profile' }" class="">
              <feather-icon icon="ArrowLeftIcon" svgClasses="text-dark" />
            </router-link>
          </li>
          <li>
            <h3>
              <td>{{ $t("setup.label.collection") }}</td>
            </h3>
          </li>
        </ul>
      </div>

      <div>
        <div>
          <div class="w-full">
            <div
              slot="no-body"
              class="tabs-container inventory_tabSec"
              id="view-customer-tab"
            >
              <vs-tabs
                alignment="fixed"
                v-model="activeTab"
                class="tab-action-btn-fill-conatiner"
              >
                <vs-tab :label="$t('setup.label.collection_trigger')">
                  <vx-card>
                    <div class="vx-row">
                      <div class="vx-col w-full md:w-full lg:w-full">
                        <ul class="horizontal-sm-btn flex mb-2 float-right">
                          <li>
                            <div
                              class="p-1 cursor-pointer flex items-center text-lg font-medium w-full"
                            >
                              <vs-button
                                color="primary"
                                icon-pack="feather"
                                icon="icon-plus"
                                class="truncate"
                                @click="collectionTriggerPopup = true"
                                size="small"
                                >{{
                                  $t("setup.label.add_collection_trigger")
                                }}</vs-button
                              >
                            </div>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div class="vx-row">
                      <div class="w-full">
                        <vs-table :data="collectionTriggers">
                          <template slot="header">
                            <div class="list-heading">
                              {{ $t("setup.label.collection_trigger") }}
                            </div>
                          </template>
                          <template slot="thead">
                            <vs-th>{{ $t("setup.label.trigger_id") }}</vs-th>
                            <vs-th>{{ $t("setup.label.criteria_type") }}</vs-th>
                            <vs-th>{{ $t("setup.label.due_balance") }}</vs-th>
                            <vs-th>{{ $t("setup.label.ageing_days") }}</vs-th>

                            <vs-th class="tHeadCenter">{{
                              $t("setup.label.Actions")
                            }}</vs-th>
                          </template>

                          <template slot-scope="{ data }">
                            <vs-tr
                              :key="index"
                              :data="item"
                              v-for="(item, index) in data"
                            >
                              <vs-td :data="item">{{ item.triggerId }}</vs-td>

                              <vs-td :data="item">{{
                                item.criteriaType
                              }}</vs-td>
                              <vs-td :data="item">{{ item.dueBalance }}</vs-td>
                              <vs-td :data="item">{{ item.ageingDays }}</vs-td>

                              <vs-td class="whitespace-no-wrap" :data="item">
                                <div class="container_img">
                                  <feather-icon
                                    icon="EditIcon"
                                    :title="$t('setup.label.Edit')"
                                    svgClasses="w-5 h-5 stroke-current cursor orange_icon"
                                    @click.stop="setTriggerData(item)"
                                    class="icon_row"
                                  />
                                  <feather-icon
                                    icon="TrashIcon"
                                    svgClasses="w-5 h-5 text-danger stroke-current cursor"
                                    color="danger"
                                    class="icon_row"
                                    :title="$t('setup.label.Delete')"
                                    type="border"
                                    size="small"
                                    @click="
                                      delId = item.triggerId;
                                      deleteTriggerPopup = true;
                                    "
                                  ></feather-icon></div
                              ></vs-td>
                            </vs-tr>
                          </template>
                        </vs-table>
                      </div>
                    </div>
                  </vx-card>
                </vs-tab>

                <vs-tab :label="$t('setup.label.collection_scenario')">
                  <vx-card>
                    <div class="vx-row">
                      <div class="vx-col w-full md:w-full lg:w-full">
                        <ul class="horizontal-sm-btn flex mb-2 float-right">
                          <li>
                            <div
                              class="p-1 cursor-pointer flex items-center text-lg font-medium w-full"
                            >
                              <vs-button
                                color="primary"
                                icon-pack="feather"
                                icon="icon-plus"
                                class="truncate"
                                @click="collectionScenerioPopup = true"
                                size="small"
                                >{{
                                  $t("setup.label.add_collection_scenario")
                                }}</vs-button
                              >
                            </div>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div class="vx-row">
                      <div class="w-full">
                        <vs-table :data="sortedCollectionScenerios">
                          <template slot="header">
                            <div class="list-heading">
                              {{ $t("setup.label.collection_scenario") }}
                            </div>
                          </template>
                          <template slot="thead">
                            <vs-th>{{ $t("setup.label.scenario_id") }}</vs-th>
                            <vs-th>{{ $t("setup.label.scenario_name") }}</vs-th>
                            <vs-th>{{ $t("setup.label.event_name") }}</vs-th>
                            <vs-th>{{ $t("setup.label.due_balance") }}</vs-th>
                            <vs-th>{{ $t("setup.label.age") }}</vs-th>

                            <vs-th class="tHeadCenter">{{
                              $t("setup.label.Actions")
                            }}</vs-th>
                          </template>

                          <template slot-scope="{ data }">
                            <vs-tr
                              :key="index"
                              :data="item"
                              v-for="(item, index) in data"
                            >
                              <vs-td :data="item">{{ item.scenarioId }}</vs-td>
                              <vs-td :data="item">{{ item.actionName }}</vs-td>
                              <vs-td :data="item">{{ item.eventName }}</vs-td>
                              <vs-td :data="item">{{ item.balancedue }}</vs-td>
                              <vs-td :data="item">{{ item.age }}</vs-td>

                              <vs-td class="whitespace-no-wrap" :data="item">
                                <div class="container_img">
                                  <feather-icon
                                    icon="EditIcon"
                                    :title="$t('setup.label.Edit')"
                                    svgClasses="w-5 h-5 stroke-current cursor orange_icon"
                                    @click.stop="setScenarioData(item)"
                                    class="icon_row"
                                  />
                                  <feather-icon
                                    icon="TrashIcon"
                                    svgClasses="w-5 h-5 text-danger stroke-current cursor"
                                    color="danger"
                                    :title="$t('setup.label.Delete')"
                                    type="border"
                                    size="small"
                                    @click="
                                      delId = item.scenarioId;
                                      deleteScenarioPopup = true;
                                    "
                                    class="icon_row"
                                  ></feather-icon></div
                              ></vs-td>
                            </vs-tr>
                          </template>
                        </vs-table>
                      </div>
                    </div>
                  </vx-card>
                </vs-tab>
              </vs-tabs>
            </div>
          </div>
        </div>
        <div class="centerx">
          <vs-popup
            classContent="popup-example"
            :title="
              isEdit
                ? $t('setup.label.edit_collection_trigger')
                : $t('setup.label.create_collection_trigger')
            "
            :active.sync="collectionTriggerPopup"
            class="popup-close"
          >
            <form>
              <div class="vx-row">
                <div
                  class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full"
                >
                  <div class="dropdown-with-label">
                    <small class="date-label"
                      >{{ $t("setup.label.criteria_type") }}
                      <span class="required"> *</span></small
                    >
                    <v-select
                      label="name"
                      :options="criteriaTypes"
                      v-model="criteriaType"
                      :placeholder="$t('placeholder.label.SelectOne')"
                      :dir="$vs.rtl ? 'rtl' : 'ltr'"
                      class="min-w-200 w-full mb-2"
                    >
                    </v-select>
                  </div>
                </div>
                <div
                  class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full"
                >
                  <vs-input
                    :label="$t('setup.label.ageing_days')"
                    class="w-full mb-2 font-semibold"
                    v-model="ageingDays"
                  />
                </div>
              </div>
              <div class="vx-row">
                <div
                  class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full"
                >
                  <vs-input
                    :label="$t('setup.label.due_balance')"
                    class="w-full mb-2 font-semibold"
                    v-model="dueBalance"
                  />
                </div>
              </div>
              <div class="vx-row center my-4">
                <div class="vx-col w-full">
                  <vs-button
                    color="primary"
                    class="footerButton-next mb-5"
                    @click="collectionTrigger"
                    >{{ $t("setup.label.Submit") }}</vs-button
                  >
                </div>
              </div>
            </form>
          </vs-popup>
        </div>
        <div class="centerx">
          <vs-popup
            classContent="popup-example"
            :title="
              isEdit
                ? $t('setup.label.edit_collection_scenario')
                : $t('setup.label.create_collection_scenario')
            "
            :active.sync="collectionScenerioPopup"
            class="popup-close"
          >
            <form>
              <div class="vx-row">
                <div
                  class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full"
                >
                  <div class="dropdown-with-label">
                    <small class="date-label"
                      >{{ $t("setup.label.scenario_name") }}
                      <span class="required"> *</span></small
                    >
                    <v-select
                      label="value"
                      :options="collectionActions"
                      v-model="scenarioName"
                      :disabled="isEdit==true"
                      :reduce="(obj) => obj.value"
                      :placeholder="$t('placeholder.label.SelectOne')"
                      :dir="$vs.rtl ? 'rtl' : 'ltr'"
                      class="min-w-200 w-full mb-2"
                    >
                    </v-select>
                  </div>
                </div>
                <div
                  class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full"
                >
                  <div class="dropdown-with-label">
                    <small class="date-label"
                      >{{ $t("setup.label.event_name") }}
                      <span class="required"> *</span></small
                    >
                    <v-select
                      label="type"
                      :options="collectionActions"
                      v-model="actionName"
                      :reduce="(obj) => obj.type"
                      :placeholder="$t('placeholder.label.SelectOne')"
                      :dir="$vs.rtl ? 'rtl' : 'ltr'"
                      class="min-w-200 w-full mb-2"
                    >
                    </v-select>
                  </div>
                </div>
                <div
                  class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full"
                >
                  <vs-input
                    :label="$t('setup.label.age')"
                    class="w-full mb-2 font-semibold"
                    v-model="age"
                  />
                </div>
                <div
                  class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full"
                >
                  <vs-input
                    :label="$t('setup.label.due_balance')"
                    class="w-full mb-2 font-semibold"
                    v-model="balancedue"
                  />
                </div>
              </div>
              <div class="vx-row center my-4">
                <div class="vx-col w-full">
                  <vs-button
                    color="primary"
                    class="footerButton-next mb-5"
                    @click="collectionScenerio"
                    >{{ $t("setup.label.Submit") }}</vs-button
                  >
                </div>
              </div>
            </form>
          </vs-popup>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { AtomSpinner } from "epic-spinners";
import { mapState } from "vuex";
import Datepicker from "vuejs-datepicker";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import DeletePopup from "@/components/DeletePopup.vue";
import vSelect from "vue-select";

export default {
  data() {
    return {
      loading: false,
      searchOption: 0,
      toggleTeam: true,
      descriptionItems: [5, 10, 15],
      collectionTriggerPopup: false,
      collectionScenerioPopup: false,
      deleteTriggerPopup: false,
      deleteScenarioPopup: false,
      delId: 0,
      activeTab: 0,
      warningPopup: false,
      criteriaTypes: ["Entry", "Exit"],
      warningText: "",
      errorMessage: "",
      criteriaType: "",
      ageingDays: "",
      dueBalance: "",
      age: "",
      actionName: "",
      scenarioName: "",
      actionFunction: "",
      balancedue: "",
      isEdit: false,
    };
  },
  components: {
    AtomSpinner,
    "delete-popup": DeletePopup,
    "v-select": vSelect,
    Datepicker,
    ValidationProvider,
    ValidationObserver,
  },

  computed: {
    ...mapState({
      collectionTriggers: (state) => state.collectionProfile.collectionTriggers,
      collectionScenerios: (state) =>
        state.collectionProfile.collectionScenerios,
      collectionActions: (state) => state.collectionProfile.collectionActions,
    }),
    sortedCollectionScenerios() {
      return [...this.collectionScenerios].sort(
        (a, b) => a.scenarioId - b.scenarioId
      );
    },
  },
  methods: {
    setTriggerData(item) {
      this.delId = item.triggerId;
      this.criteriaType = item.criteriaType;
      this.ageingDays = item.ageingDays;
      this.dueBalance = item.dueBalance;
      this.isEdit = true;
      this.collectionTriggerPopup = true;
    },
    setScenarioData(item) {
      this.delId = item.scenarioId;
      this.age = item.age;
      this.actionName = item.eventName;
      this.scenarioName = item.actionName;
      this.balancedue = item.balancedue;
      this.isEdit = true;
      this.collectionScenerioPopup = true;
    },
    async deleteTrigger(id) {
      try {
        await this.$store.dispatch(
          "collectionProfile/deleteCollectionTriggerAction",
          id
        );
        this.$swal({
            title: "Success",
            icon: "success",
            text: "Collection Trigger Deleted Successfully!",
            type: "success",
          });
        this.$store.dispatch(
          "collectionProfile/getCollectionTriggersAction",
          this.$route.params.id
        );
        this.deleteTriggerPopup = false;
      } catch (e) {
        this.errorMessage = e.message.replace("The parameter", "");
        this.warningPopup = true;
        this.errors = e.message;
      }
    },
    async deleteScenario(id) {
      try {
        await this.$store.dispatch(
          "collectionProfile/deleteCollectionScenarioAction",
          id
        );
        this.$swal({
            title: "Success",
            icon: "success",
            text: "Collection Scenario Deleted Successfully!",
            type: "success",
          });
        this.$store.dispatch(
          "collectionProfile/getCollectionScenariosAction",
          this.$route.params.id
        );
        this.deleteScenarioPopup = false;
      } catch (e) {
        this.errorMessage = e.message.replace("The parameter", "");
        this.warningPopup = true;
        this.errors = e.message;
      }
    },
    async collectionTrigger() {
      let payload = {
        profileId: this.$route.params.id,
        criteriaType: this.criteriaType,
        ageingDays: this.ageingDays,
        dueBalance: this.dueBalance,
        locale: "en",
      };
      try {
        if (!this.isEdit){
          await this.$store.dispatch(
            "collectionProfile/createCollectionTriggerAction",
            payload
          );
          await this.$swal({
        title: "Success",
        icon: "success",
        text: "Collection Trigger Created Successfully!",
        type: "success",
      });
        } else {
          await this.$store.dispatch(
            "collectionProfile/editCollectionTriggerAction",
            { id: this.delId, data: payload }
          );
          await this.$swal({
        title: "Success",
        icon: "success",
        text: "Collection Trigger Updated Successfully!",
        type: "success",
      });
        }
        this.collectionTriggerPopup = false;
        this.criteriaType = "";
        this.ageingDays = "";
        this.dueBalance = "";
        this.$store.dispatch(
          "collectionProfile/getCollectionTriggersAction",
          this.$route.params.id
        );
      } catch (e) {
        this.errorMessage = e.message.replace("The parameter", "");
        this.warningPopup = true;
        this.errors = e.message;
      }
    },
    async collectionScenerio() {
      const event = this.collectionActions.find(item => item.type === this.actionName);
      let payload = {
        profileId: this.$route.params.id,
        age: this.age,
        actionName: this.scenarioName,
        balancedue: this.balancedue,
        locale: "en",
        eventId: event.id,
        eventName: this.actionName
      };
      try {
        if (!this.isEdit){
          await this.$store.dispatch(
            "collectionProfile/createCollectionSceneriosAction",
            payload
          );
          await this.$swal({
        title: "Success",
        icon: "success",
        text: "Collection Scenario Created Successfully!",
        type: "success",
      });
        } else {
          await this.$store.dispatch(
            "collectionProfile/editCollectionScenarioAction",
            { id: this.delId, data: payload }
          );
          await this.$swal({
        title: "Success",
        icon: "success",
        text: "Collection Scenario Updated Successfully!",
        type: "success",
      });
        }
        this.collectionScenerioPopup = false;
        this.age = "";
        this.actionName = "";
        this.scenarioName = "";
        this.balancedue = "";
        this.$store.dispatch(
          "collectionProfile/getCollectionScenariosAction",
          this.$route.params.id
        );
      } catch (e) {
        this.errorMessage = e.message.replace("The parameter", "");
        this.warningPopup = true;
        this.errors = e.message;
      }
    },
  },
  watch: {
    collectionTriggerPopup(val) {
      if (!val) {
        this.criteriaType = "";
        this.ageingDays = "";
        this.dueBalance = "";
        this.isEdit = false;
      }
    },
    collectionScenerioPopup(val) {
      if (!val) {
        this.age = "";
        this.actionName = "";
        this.scenarioName = "";
        this.balancedue = "";
        this.isEdit = false;
      }
    },
  },
  mounted() {
    this.$store.dispatch(
      "collectionProfile/getCollectionTriggersAction",
      this.$route.params.id
    );
    this.$store.dispatch(
      "collectionProfile/getCollectionScenariosAction",
      this.$route.params.id
    );
    this.$store.dispatch("collectionProfile/fetchCollectionActions");
  },
};
</script>
<style scoped>
::v-deep .vs-tabs--ul {
  width: 100%;
}
.inventory_tabSec >>> .con-vs-tabs .vs-tabs--ul {
  box-shadow: none !important;
}

.table {
  width: 100%;
  max-width: 100%;
  margin-bottom: 20px;
  background-color: #fff;
  border: solid 1px #f0f0f0;
}

.table td {
  vertical-align: middle;
  border-top: none;
  padding: 10px 7px;
  font-size: 14px;
  color: #646a71;
  border-bottom: 1px solid #dfe3e7;
  transition: all 0.2s ease;
  overflow: hidden;
  word-break: break-all;
}
</style>
